import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { FloorGuideActions, FloorGuideState } from './types/floorGuide';

export const useFloorGuideStore = create<FloorGuideState & FloorGuideActions>()(
    devtools(
        (set) => ({
            selectedPoi: undefined,
            floorGuideType: undefined,
            selectedParkingSlot: undefined,

            setSelectedPoi: (poi) => {
                set({ selectedPoi: poi });
            },

            setFloorGuideType: (floorGuideType) => {
                set({ floorGuideType });
            },

            resetSelectedPoi: () => {
                set({ selectedPoi: undefined });
            },

            resetFloorGuideType: () => {
                set({ floorGuideType: undefined });
            },

            setSelectedParkingSlot: (selectedParkingSlot) => {
                set({ selectedParkingSlot });
            },

            resetSelectedParkingSlot: () => {
                set({ selectedParkingSlot: undefined });
            },
        }),
        {
            name: 'floor-guide-store',
        }
    )
);
